import API from '@api/yearMerchant'
import Api from '@components/Store/AccountManage/api'
import { message } from 'hljd'
import { action, computed, observable } from 'mobx'
import moment from 'moment'
import { materialPropertyMap } from './constant'

export default class Dialog {
  @observable wechatSrc = ''
  @observable showWechatDialog = false
  @observable yearReviewStatus = 0
  @observable isShowModal = false
  @observable propertyId // 商家类目id
  @observable selectedList = []

  @computed
  get materialType() {
    if (!this.propertyId) {
      return null
    }
    const type = Object.keys(materialPropertyMap).find(type =>
      materialPropertyMap[type].includes(this.propertyId)
    )
    return type ? +type : null
  }

  @action
  setPropertyId = propertyId => {
    this.propertyId = propertyId
  }
  @action
  setSelectedList = selectedList => {
    this.selectedList = selectedList
  }

  @action
  showModal = () => {
    this.isShowModal = true
  }
  @action
  hideModal = () => {
    this.selectedList = []
    this.isShowModal = false
  }
  @action
  getWechatNotice = async () => {
    const { data } = await Api.getWechatNotice()
    this.wechatSrc = data
  }
  @action
  getYearReviewStatus = async () => {
    const { success, data } = await API.yearReviewStatus()
    if (success) {
      if (data.showBindWechat) {
        this.handleWechatBindShow()
      }
      this.yearReviewStatus = data.yearReviewStatus
    }
  }
  // 关闭年度商家对话框
  @action
  closeDialog = async type => {
    const { success } = await API.closeYearReview()
    if (success) {
      this.yearReviewStatus = 0
    }
  }
  @action
  getSelectedMaterial = async () => {
    const { success, data } = await API.materialList({
      materialType: this.materialType
    })
    if (success) {
      this.selectedList = data.materialIds
        ? data.materialIds.map(id => ({
            id
          }))
        : []
    }
  }
  @action
  submitMaterial = async () => {
    const materialIds = this.selectedList.map(item => item.id)
    const { success } = await API.submitMaterial({
      materialType: this.materialType,
      materialIds
    })
    if (success) {
      if (this.yearReviewStatus == 4) {
        message.success('提报成功')
        this.yearReviewStatus = 5
      } else {
        message.success('修改成功')
      }
      this.hideModal()
    }
  }

  // 业务中处理是否展示微信绑定的逻辑
  handleWechatBindShow = async () => {
    const weChatTipData = JSON.parse(localStorage.getItem('weChatTip'))
    const closeTime = weChatTipData && weChatTipData.time
    const isSameDay = closeTime && moment().isSame(closeTime, 'day')
    const closeCount = weChatTipData ? weChatTipData.weChatTipTime : 0
    if (closeCount >= 3 || isSameDay) {
      this.showWechatDialog = false
      return
    }
    const isBind = await this.checkWechatBind()
    if (!isBind) {
      await this.getWechatNotice()
      this.showWechatDialog = true
    }
  }
  // 关闭微信绑定对话框
  closeWechatDialog = () => {
    this.showWechatDialog = false
    const weChatTipData = JSON.parse(localStorage.getItem('weChatTip'))
    const closeCount = weChatTipData ? weChatTipData.weChatTipTime : 0
    localStorage.setItem(
      'weChatTip',
      JSON.stringify({
        weChatTipTime: closeCount + 1,
        time: +new Date()
      })
    )
  }
  checkWechatBind = async () => {
    let { data } = await Api.checkWechatBindNotice()
    return data.isBind
  }
}
